import Vue from "vue";
import App from "./App.vue";
import store from "./store";

import router from "./router";
import i18n from "@/plugins/i18n";
import Config from "./managers/ConfigManager";

import Buefy from "buefy";
import * as VueGoogleMaps from "vue2-google-maps";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

Vue.use(Buefy);
Vue.use(VueGoogleMaps, {
  load: {
    key: Config.getMapKey(),
    libraries: "places, drawing"
  }
});

Vue.component("VueSlider", VueSlider);
Vue.config.productionTip = false;

new Vue({
  i18n,
  store,
  router,
  render: h => h(App)
}).$mount("#app");
